import { Inject, Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { isEmpty } from '../../../common/functions';
import { InsectaServiceBase } from '../insecta.base.service';
import { IContainerType } from '../insecta.models';
import { DictionaryCacheService } from '../dictionary-cache.service';
import { HttpClient } from '@angular/common/http';
import { SETTINGS, Settings } from '../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class ContainerTypeAdminService extends InsectaServiceBase {
  constructor(
    private http: HttpClient,
    @Inject(SETTINGS) settings: Settings,
    private dictionaryCache: DictionaryCacheService
  ) {
    super(http, settings);
  }
  public addContainerType(containertype: IContainerType): Observable<string> {
    return this.post<string>(`/admin/containertypes`, `v1`, {
      name: containertype.name,
      isActive: containertype.isActive,
      username: containertype.actionBy
    }).pipe(tap(() => this.dictionaryCache.invalidate('containertype')));
  }

  public getContainerType(id: string): Observable<IContainerType> {
    return this.get<IContainerType>(`/admin/containertypes/${id}`, 'v1');
  }

  public getContainerTypes(includeInActive: boolean | null | undefined): Observable<IContainerType[]> {
    if (isEmpty(includeInActive)) includeInActive = false;

    return this.get<IContainerType[]>(`/admin/containertypes`, 'v1').pipe(
      map((results) => [...results].filter((x: IContainerType) => includeInActive || x.isActive)),
      map((results) =>
        [...results].sort((a: IContainerType, b: IContainerType) =>
          a.isActive == b.isActive ? (a.name > b.name ? 1 : -1) : a.isActive < b.isActive ? 1 : -1
        )
      )
    );
  }

  public getContainerTypeAll(): Observable<IContainerType[]> {
    return this.getContainerTypes(true);
  }

  public updateContainerType(containertype: IContainerType): Observable<any> {
    return this.put<IContainerType>(`/admin/containertypes/${containertype.id}`, `v1`, {
      id: containertype.id,
      name: containertype.name,
      isActive: containertype.isActive,
      username: containertype.actionBy
    }).pipe(tap(() => this.dictionaryCache.invalidate('containertype')));
  }
}
